export const VIEW_MODE = 'app/components/AccountLocationSelect/VIEW_MODE';
export const EDIT_MODE = 'app/components/AccountLocationSelect/EDIT_MODE';

export const CREATE_LOCATION = 'app/components/AccountLocationSelect/CREATE_LOCATION';
export const EDIT_LOCATION = 'app/components/AccountLocationSelect/EDIT_LOCATION';
export const SET_MODE = 'app/components/AccountLocationSelect/SET_MODE';
export const SWITCH_TO_EDIT_MODE = 'app/components/AccountLocationSelect/SWITCH_TO_EDIT_MODE';
export const SWITCH_TO_VIEW_MODE = 'app/components/AccountLocationSelect/SWITCH_TO_VIEW_MODE';
